<template>
  <Transition name="search-fade">
    <div
      v-if="store.isActive"
      class="fixed inset-0 z-40 bg-white"
      :style="{ paddingTop: 'calc(env(safe-area-inset-top) + 62px)' }"
    >
      <MobileSearchCombined
        v-if="showResults && store.view === 'combined'"
        class="h-full overflow-y-auto overscroll-contain"
        @view-all="store.setView($event)"
      />
      <MobileSearchPrivate
        v-else-if="showResults && store.view === 'private'"
      />
      <MobileSearchPublic v-else-if="showResults && store.view === 'public'" />

      <div
        v-else-if="store.query.length === 1"
        class="flex h-[60px] w-full items-center justify-center text-[15px] leading-[18px] text-gray-500"
      >
        Your search must be at least 2 characters long
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useMobileSearchStore } from '@/features/search/store'
import MobileSearchCombined from '@/features/search/components/mobile/MobileSearchCombined.vue'
import MobileSearchPrivate from '@/features/search/components/mobile/MobileSearchPrivate.vue'
import MobileSearchPublic from '@/features/search/components/mobile/MobileSearchPublic.vue'

const store = useMobileSearchStore()
const route = useRoute()

const showResults = computed(() => store.query.length > 1)

watch(
  () => route.fullPath,
  () => {
    if (store.isActive) store.close()
  }
)
</script>

<style scoped>
.search-fade-enter-active,
.search-fade-leave-active {
  transition: opacity 0.15s ease;
}

.search-fade-enter-from,
.search-fade-leave-to {
  opacity: 0;
}
</style>
